import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'ConfirmationDialog' })((theme) => ({
  confirmationTextField: {
    marginTop: theme.spacing(1),
  },
  tertiary: {
    marginRight: 'auto',
  },
}));

export default useStyles;
